import './plugins/sentry'
import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
import i18n from './i18n/i18n'
import vuetify from './plugins/vuetify'
import highligth from './plugins/highlight'
import markdown from './plugins/markdown'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import '@/styles/global.scss'
import '@/domains/opportunity/assets/style/variables.scss'
import { onClickOutsideDirective } from '@/domains/opportunity/shared/event/clickOutside'

Vue.config.productionTip = false
Vue.config.ignoredElements = ['gtr-form-widget', 'gtr-review-widget', 'gtr-review-display-widget']
Vue.use(VueDOMPurifyHTML)

Vue.directive('on-click-outside', onClickOutsideDirective)

new Vue({
  router,
  store,
  i18n,
  vuetify,
  highligth,
  markdown,
  render: h => h(App),
}).$mount('#app')
